import { Funcionalidades } from '@/config/funcionalidades';
// import TelemetriaPantalla from './Dashboard/TelemetriaPantalla.vue';
// import ReportePantalla from './Reporte/ReportePantalla.vue';
// import DatosPantalla from './DatosInstantaneos/DatosPantalla.vue';

const TelemetriaRoutes = [
  {
    path: 'Telemetria-Dashboard',
    component: () => import('./Dashboard/TelemetriaPantalla.vue'),
    meta: {
      description: 'Dashboard',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.TelemetriaDashboard,
    },
  },
  {
    path: 'Reportes-Telemetria',
    component: () => import('./Reporte/ReportePantalla.vue'),
    meta: {
      description: 'Reportes Telemetria',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.TelemetriaDashboard,
    },
  },
  {
    path: 'Datos-Instantaneos',
    component: () => import('./DatosInstantaneos/DatosPantalla.vue'),
    meta: {
      description: 'Datos Instantáneos',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.TelemetriaDashboard,
    },
  },
  {
    path: 'Alertas-Combustible',
    component: () => import('./FugaCombustible/Pantalla.vue'),
    meta: {
      description: 'Configuración Alertas',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.FugaCombustible,
    },
  },
];

export default TelemetriaRoutes;
